import React, { memo } from 'react'
import { HeadingText, Link, BodyText } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import {
  DATA_PRIVACY_SETTINGS,
  MERCHANT_DATA_PRIVACY_SETTINGS,
} from '../../constants/constants'
import serverData from '../../utils/server-data'
const { isMerchantUser } = serverData
const PrivacyChoices = memo((props) => (
  <div className="privacyHub-model">
    <HeadingText
      id="privacyChoicesHeader"
      className="privacyHub-model-heading"
      size="lg"
    >
      <Message id="privacyhub.privacychoices.header" />
    </HeadingText>
    <BodyText size="lg" className="privacyHub-model-content">
      <Message
        id="privacyhub.privacychoices.component.desc"
        link={(innerMessage) => (
          <Link
            theme="v2"
            id="privacySettingsLink"
            name="privacy_settings"
            href={
              isMerchantUser
                ? MERCHANT_DATA_PRIVACY_SETTINGS
                : DATA_PRIVACY_SETTINGS
            }
          >
            {innerMessage}
          </Link>
        )}
      />
    </BodyText>

    {props.content(props.keys && props.keys.privacychoices)}
  </div>
))

PrivacyChoices.displayName = 'PrivacyChoices'

export default PrivacyChoices
